import React, { useContext, useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import '../styles/style.css';

import { Link } from 'react-router-dom';
import icon_menu_home from '../images/menu/icon_menu_home.svg';
import icon_menu_analysis from '../images/menu/icon_menu_analysis.svg';
import icon_menu_analysis_disabled from '../images/menu/icon_menu_analysis_disabled.svg';
import icon_menu_transform from '../images/menu/icon_menu_transform.svg';
import icon_menu_transform_disabled from '../images/menu/icon_menu_transform_disabled.svg';
import icon_menu_help from '../images/menu/icon_menu_help.svg';

import icon_tablecharts from '../images/icon_tablecharts.svg';
import icon_charts from '../images/icon_charts.svg';
import icon_table from '../images/icon_table.svg';

import icon_selected_tablecharts from '../images/icon_selected_tablecharts.svg';
import icon_selected_charts from '../images/icon_selected_charts.svg';
import icon_selected_table from '../images/icon_selected_table.svg';

import { AppContext } from 'context/AppContext';

let activeProject = localStorage.getItem('activeProject');

const { Sider } = Layout;

const NavigationApp = () => {
    const [collapsed, setCollapsed] = useState(true);
    const [keyMenuNumber, setKeyMenuNumber] = useState(0);

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    };

    const [windowSize, setWindowSize] = useState(getWindowSize());

    let appContext = useContext(AppContext);

    useEffect(() => {
        activeProject = localStorage.getItem('activeProject');
    }, [appContext.currentLocation]);

    const handleMenuItemState = (currentProject) => {
        return currentProject === null ? true : false;
    };

    const handleMenuIconAnalysisState = (currentProject) => {
        return currentProject !== null
            ? icon_menu_analysis
            : icon_menu_analysis_disabled;
    };

    const handleMenuIconTransformState = (currentProject) => {
        return currentProject !== null
            ? icon_menu_transform
            : icon_menu_transform_disabled;
    };

    const menuOnSelect = (e) => {
        if (e.key == 2) {
            setKeyMenuNumber(2);
        } else if (e.key == 3) {
            setKeyMenuNumber(3);
        } else {
            setKeyMenuNumber(0);
            return null;
        }
    };

    let navHelpColor = appContext.helpNavIsVisible ? '#407cb1' : '';
    let navHelpColorHome =
        appContext.helpNavIsVisible && appContext.currentLocation == '1'
            ? '#3d3f4d'
            : '';
    let navHelpColorProject =
        appContext.helpNavIsVisible && appContext.currentLocation == '2'
            ? '#3d3f4d'
            : '';
    let navHelpColorTransform =
        appContext.helpNavIsVisible && appContext.currentLocation == '3'
            ? '#3d3f4d'
            : '';

    return (
        <>
            <Sider
                id="sider-menu-left"
                trigger={null}
                collapsible
                collapsed={collapsed}
                collapsedWidth={60}
                style={{
                    height: '100vh',
                    position: 'sticky',
                    top: 0
                }}
            >
                <div>
                    <Menu
                        onSelect={menuOnSelect}
                        theme="dark"
                        mode="inline"
                        selectedKeys={appContext.currentLocation}
                        triggerSubMenuAction="click"
                    >
                        <Menu.Item
                            style={{ backgroundColor: navHelpColorHome }}
                            onClick={() => {
                                appContext.setHelpNavIsVisible(false);
                            }}
                            key="1"
                            icon={
                                <img
                                    className="icon_menu"
                                    src={icon_menu_home}
                                />
                            }
                            title=""
                        >
                            <Link to="/" className="menu-name-page">
                                My projects
                            </Link>
                        </Menu.Item>

                        <Menu.Item
                            style={{ backgroundColor: navHelpColorProject }}
                            onClick={() => {
                                appContext.setHelpNavIsVisible(false);
                            }}
                            key="2"
                            disabled={handleMenuItemState(
                                localStorage.getItem('activeProject')
                            )}
                            icon={
                                <img
                                    onClick={() => {
                                        if (appContext.currentLocation == '2')
                                            appContext.setAsideIsVisible(
                                                !appContext.asideIsVisible
                                            );
                                    }}
                                    className="icon_menu"
                                    src={handleMenuIconAnalysisState(
                                        localStorage.getItem('activeProject')
                                    )}
                                />
                            }
                            title=""
                        >
                            {appContext.currentLocation != '2' && (
                                <Link
                                    to={`/project/${activeProject}`}
                                    className="menu-name-page"
                                >
                                    Analysis
                                </Link>
                            )}
                        </Menu.Item>

                        <Menu.Item
                            style={{
                                backgroundColor: navHelpColorTransform
                            }}
                            onClick={() => {
                                appContext.setHelpNavIsVisible(false);
                            }}
                            key="3"
                            disabled={handleMenuItemState(
                                localStorage.getItem('activeProject')
                            )}
                            icon={
                                <img
                                    onClick={() => {
                                        if (appContext.currentLocation == '3')
                                            appContext.setAsideIsVisible(
                                                !appContext.asideIsVisible
                                            );
                                    }}
                                    className="icon_menu"
                                    src={handleMenuIconTransformState(
                                        localStorage.getItem('activeProject')
                                    )}
                                />
                            }
                            title=""
                        >
                            {appContext.currentLocation != '3' && (
                                <Link
                                    to={`/transform/${activeProject}`}
                                    className="menu-name-page"
                                >
                                    Transform
                                </Link>
                            )}
                        </Menu.Item>

                        <Menu.Divider></Menu.Divider>
                        <Menu.Item
                            onClick={() => {
                                appContext.setHelpNavIsVisible(
                                    !appContext.helpNavIsVisible
                                );
                            }}
                            style={{ backgroundColor: navHelpColor }}
                            key="4"
                            icon={
                                <img
                                    className="icon_menu"
                                    src={icon_menu_help}
                                />
                            }
                        >
                            {/* <Link to="/" className="menu-name-page">
                                Help
                            </Link> */}
                        </Menu.Item>
                    </Menu>
                </div>
                {/* {showIconsHowDisplayProject === 2 ||
                showIconsHowDisplayProject === 3 ? ( */}

                {appContext.currentLocation == '1' ? null : (
                    <div
                        style={{
                            marginBottom: windowSize.innerHeight >= 750 ? 0 : 60
                        }}
                        className="container-to-icon-project-view"
                    >
                        <div>
                            <img
                                onClick={() => {
                                    appContext.setAnalysisTableChartDisplay(
                                        'tablechart'
                                    );
                                }}
                                src={
                                    appContext.analysisTableChartDisplay ===
                                    'tablechart'
                                        ? icon_selected_tablecharts
                                        : icon_tablecharts
                                }
                            />
                        </div>

                        <div>
                            <img
                                onClick={() => {
                                    appContext.setAnalysisTableChartDisplay(
                                        'chart'
                                    );
                                }}
                                src={
                                    appContext.analysisTableChartDisplay ===
                                    'chart'
                                        ? icon_selected_charts
                                        : icon_charts
                                }
                            />
                        </div>
                        <div>
                            <img
                                onClick={() => {
                                    appContext.setAnalysisTableChartDisplay(
                                        'table'
                                    );
                                }}
                                src={
                                    appContext.analysisTableChartDisplay ===
                                    'table'
                                        ? icon_selected_table
                                        : icon_table
                                }
                            />
                        </div>
                    </div>
                )}
                {/* ) : null} */}
            </Sider>
        </>
    );
};

export default NavigationApp;
